import gql from 'graphql-tag';

export const UPDATE_EQUIPMENT = gql`
  mutation UpdateEquipment($input: UpsertEquipmentInput!) {
    upsertEquipment(input: $input) {
      id
    }
  }
`;
